import type { BifrostWeb } from '@seekrtech/bifrost-web'

// only for relax-paywall app
export interface AdditionalServiceMethods {
  getInitialThemeId: () => Promise<number>
}

// only for relax-paywall app
export function createAdditionalService(
  bifrost: BifrostWeb,
): AdditionalServiceMethods {
  return bifrost.createNativeProxy<AdditionalServiceMethods>(
    'RelaxPaywallService',
  )
}
